import { hydrateRoot } from 'react-dom/client';
import { NftPdpWrapper } from '../nftPdp/NftPdpWrapper';
import serverVars from 'server-vars';
import { RelayEnvironmentProvider } from 'react-relay';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';

const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
    // necessary for hydrating preview/draft
    ...(serverVars.get('relay.relayData') || {}),
});

initializeDBL().then(({ store }) => {
    hydrateRoot(
        document.getElementById('js-root'),
        <RelayEnvironmentProvider environment={environment}>
            <NftPdpWrapper
                locale={serverVars.get('locale')}
                deviceType={serverVars.get('deviceType')}
                store={store}
                variables={serverVars.get('relay.variables')}
            />
        </RelayEnvironmentProvider>
    );
});
